/* v6 — modal stays open after add */
(function(){
'use strict';

/* ─── INTRO ─── */
(function(){
  var intro = document.getElementById('intro');
  if(!intro) return;
  try {
    if(sessionStorage.getItem('sw_intro_seen')){
      intro.parentNode && intro.parentNode.removeChild(intro);
      return;
    }
    sessionStorage.setItem('sw_intro_seen','1');
  } catch(e){}
  var bar = document.querySelector('.intro-progress-bar');
  if(bar) requestAnimationFrame(function(){ bar.style.width='100%'; });
  var hidden = false;
  function hide(){
    if(hidden) return; hidden = true;
    intro.classList.add('hidden');
    setTimeout(function(){ intro.parentNode && intro.parentNode.removeChild(intro); }, 600);
  }
  if(document.readyState === 'complete') setTimeout(hide, 300);
  else window.addEventListener('load', function(){ setTimeout(hide, 150); }, {once:true});
  setTimeout(hide, 700);
})();


/* ─── ZUTATEN POPUP ─── */
(function(){
  if(document.getElementById('zt-overlay')) return;
  var html =
    '<div class="zt-overlay" id="zt-overlay" aria-hidden="true" role="dialog">'+
      '<div class="zt-backdrop" id="zt-backdrop"></div>'+
      '<div class="zt-box" id="zt-box">'+
        '<div class="zt-header">'+
          '<div class="zt-header-left">'+
            '<div class="zt-pretitle">'+
              '<svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>'+
              'Zutaten &amp; Beschreibung'+
            '</div>'+
            '<div class="zt-title" id="zt-title"></div>'+
          '</div>'+
          '<button class="zt-close" id="zt-close" aria-label="Schlie\u00dfen">'+
            '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'+
          '</button>'+
        '</div>'+
        '<div class="zt-body">'+
          '<div class="zt-content" id="zt-content"></div>'+
        '</div>'+
      '</div>'+
    '</div>';
  var div = document.createElement('div');
  div.innerHTML = html;
  document.body.appendChild(div.firstChild);

  function closeZt(){
    var ov = document.getElementById('zt-overlay');
    if(!ov) return;
    ov.classList.remove('open');
    setTimeout(function(){ ov.setAttribute('aria-hidden','true'); }, 350);
  }

  document.getElementById('zt-backdrop').addEventListener('click', closeZt);
  document.getElementById('zt-close').addEventListener('click', closeZt);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeZt(); });
})();

function openZutatenPopup(name, desc){
  var ov = document.getElementById('zt-overlay');
  var titleEl = document.getElementById('zt-title');
  var contentEl = document.getElementById('zt-content');
  if(!ov || !titleEl || !contentEl) return;

  titleEl.textContent = name || '';
  var raw = (desc || '').trim();

  if(!raw){
    contentEl.innerHTML =
      '<div class="zt-empty">'+
        '<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="1.5">'+
          '<circle cx="12" cy="12" r="10"/>'+
          '<line x1="12" y1="8" x2="12" y2="12"/>'+
          '<line x1="12" y1="16" x2="12.01" y2="16"/>'+
        '</svg>'+
        '<p>Keine Beschreibung vorhanden.</p>'+
      '</div>';
  } else {
    var clean = raw;
    var hasBlockTags = /<(p|ul|ol|h[2-6]|li|br)[\s>]/i.test(clean);

    if(!hasBlockTags){
      var parts = clean.split(/\s*[\u2013\u2014-]{1,2}\s*/);
      var result = '';
      var inList = false;

      parts.forEach(function(part){
        part = part.trim();
        if(!part) return;
        var isHeader = /\d+\s+Option/i.test(part);
        if(isHeader){
          if(inList){ result += '</ul>'; inList = false; }
          result += '<h3 class="zt-section-title">' + part + '</h3><ul>';
          inList = true;
        } else {
          if(!inList){ result += '<ul>'; inList = true; }
          result += '<li>' + part + '</li>';
        }
      });

      if(inList) result += '</ul>';
      clean = result || '<p>' + clean + '</p>';
    }

    contentEl.innerHTML = '<div class="zt-html-content">' + clean + '</div>';
  }

  ov.setAttribute('aria-hidden','false');
  ov.classList.add('open');
  var body = ov.querySelector('.zt-body');
  if(body) body.scrollTop = 0;
}


/* ─── REVEAL ON SCROLL ─── */
(function(){
  var els = document.querySelectorAll('.rv');
  if(!els.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.08 });
  els.forEach(function(el){ io.observe(el); });
})();

/* ─── DELIVERY DATE ─── */
(function(){
  var dateInput = document.getElementById('del-date');
  if(!dateInput) return;
  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate()+1);
  dateInput.min = tomorrow.toISOString().split('T')[0];
  dateInput.addEventListener('change', function(){
    sessionStorage.setItem('sw_delivery_date', this.value);
    updateCartNote();
  });
  var timeInput = document.getElementById('del-time');
  if(timeInput) timeInput.addEventListener('change', function(){
    sessionStorage.setItem('sw_delivery_time', this.value);
    updateCartNote();
  });
})();

function updateCartNote(){
  var date = sessionStorage.getItem('sw_delivery_date')||'';
  var time = sessionStorage.getItem('sw_delivery_time')||'';
  if(!date && !time) return;
  var note = '';
  if(date) note += 'Lieferdatum: '+date+'\n';
  if(time) note += 'Lieferzeit: '+time+' Uhr\n';
  fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:note})}).catch(function(){});
}

/* ─── NAV BADGE ─── */
function updateBadge(){
  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
    var badge = document.getElementById('nav-badge');
    var badge2 = document.getElementById('sw-nav-badge');
    var badge3 = document.getElementById('sw-fp-cart-badge');
    if(badge) badge.textContent = cart.item_count;
    if(badge2) badge2.textContent = cart.item_count;
    if(badge3){
      badge3.textContent = cart.item_count;
      badge3.classList.remove('bump');
      void badge3.offsetWidth;
      badge3.classList.add('bump');
    }
  }).catch(function(){});
}
updateBadge();

/* ─── STATE ─── */
var selectedVariantId = null;
var selectedQty = 1;
var selectedTitle = '';

/* ─── OVERLAY ELEMENTS ─── */
var overlay = document.getElementById('prod-overlay');
var prodBack = document.getElementById('prod-back');
var prodTitle = document.getElementById('prod-title');
var prodList = document.getElementById('prod-list');
var overlayFooter = document.getElementById('overlay-footer');
var footerQtyVal = document.getElementById('footer-qty-val');
var footerAddBtn = document.getElementById('footer-add-btn');
var footerPrice = document.getElementById('footer-price');

/* ─── OPEN CATEGORY ─── */
document.querySelectorAll('.cat-card').forEach(function(card){
  card.addEventListener('click', function(){
    var handle = this.getAttribute('data-handle');
    var name = this.querySelector('.cat-card-name') ? this.querySelector('.cat-card-name').textContent : handle;
    openCollection(handle, name);
  });
});

function resolveStory(handle, name){
  var stories = window.SW_CAT_STORY || {};
  var keywords = window.SW_CAT_KEYWORDS || [];
  if(!handle) return null;
  if(stories[handle]) return stories[handle];
  var keys = Object.keys(stories).sort(function(a,b){ return b.length - a.length; });
  for(var i = 0; i < keys.length; i++){
    var key = keys[i];
    if(handle === key) return stories[key];
    if(handle.length > key.length && handle.indexOf(key + '-') === 0) return stories[key];
    if(key.length > handle.length && key.indexOf(handle + '-') === 0) return stories[key];
    if(handle === key + 'n' || handle === key + 's' || key === handle + 'n' || key === handle + 's') return stories[key];
  }
  var hay = (String(handle || '') + ' ' + String(name || '')).toLowerCase();
  for(var j = 0; j < keywords.length; j++){
    var entry = keywords[j];
    for(var m = 0; m < entry.match.length; m++){
      if(hay.indexOf(entry.match[m]) !== -1){
        if(stories[entry.storyKey]) return stories[entry.storyKey];
      }
    }
  }
  return null;
}

function openCollection(handle, name){
  if(!overlay){ window.location.href = '/collections/' + handle; return; }
  updateBadge();
  overlay.style.display = 'flex';
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ overlay.classList.add('sw-open'); }); });

  document.dispatchEvent(new CustomEvent('sw:open'));

  if(prodTitle) prodTitle.textContent = name;
  if(prodList) prodList.innerHTML = '<div class="prod-loading sw-loading">Wird geladen\u2026</div>';
  if(overlayFooter) overlayFooter.style.display = 'none';
  selectedVariantId = null;

  var handwerkEl = document.getElementById('sw-handwerk');
  var _earlyStory = null;
  if(handwerkEl){
    var BLANK = 'data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%204%205%27%2F%3E';
    _earlyStory = resolveStory(handle, name);
    function _bust(u){ if(!u) return u; return u + (u.indexOf('?') === -1 ? '?' : '&') + 'sw=' + (window.SW_CACHE_BUST || '7'); }

    var preImgs = handwerkEl.querySelectorAll('.sw-handwerk-img img');
    handwerkEl.style.display = 'none';
    if(_earlyStory){
      var earlyUrls = [_bust(_earlyStory.img1), _bust(_earlyStory.img2), _bust(_earlyStory.img3)];
      earlyUrls.forEach(function(u){
        if(!u) return;
        try {
          var lp = document.createElement('link');
          lp.rel = 'preload'; lp.as = 'image'; lp.href = u;
          try { lp.fetchPriority = 'high'; } catch(e){}
          document.head.appendChild(lp);
          setTimeout(function(){ try { lp.remove(); } catch(e){} }, 30000);
        } catch(e){}
        try { var imgPre = new Image(); imgPre.src = u; } catch(e){}
      });
      for(var pi = 0; pi < preImgs.length; pi++){
        preImgs[pi].removeAttribute('srcset');
        try { preImgs[pi].fetchPriority = 'high'; } catch(e){}
        preImgs[pi].loading = 'eager';
        preImgs[pi].decoding = 'async';
        if(earlyUrls[pi]) preImgs[pi].src = earlyUrls[pi];
      }
    } else {
      for(var pj = 0; pj < preImgs.length; pj++){
        preImgs[pj].removeAttribute('srcset');
        preImgs[pj].src = BLANK;
        preImgs[pj].alt = '';
      }
    }
  }

  fetch('/collections/'+handle+'/products.json?limit=250&sort_by=price-ascending')
    .then(function(r){ return r.json(); })
    .then(function(data){
      var prods = data.products || [];
      var countEl = document.getElementById('sw-prod-count');
      if(countEl) countEl.textContent = prods.length;
      renderProducts(prods);

      if(handwerkEl){
        var blockedHandles = ['fingerfood','all','getranke'];
        var hasSpace = prods.length > 0 && prods.length <= 15;
        var allowed = blockedHandles.indexOf(handle) === -1;
        var showHw = allowed && hasSpace;

        if(showHw){
          var story = resolveStory(handle, name);
          try { console.log('[SW_CAT_STORY] handle=', handle, 'name=', name, 'matched=', story && story.heading); } catch(e){}
          var titleEl = handwerkEl.querySelector('.sw-handwerk-title');
          var subEl   = handwerkEl.querySelector('.sw-handwerk-sub');
          var imgs    = handwerkEl.querySelectorAll('.sw-handwerk-img img');
          var caps    = handwerkEl.querySelectorAll('.sw-handwerk-cap');
          var defaultSub = 'Frisch geschnitten, mit Sorgfalt belegt, bereit zum Mitnehmen — jeden Tag neu aus unserer Werkstatt.';
          function bust(u){ if(!u) return u; return u + (u.indexOf('?') === -1 ? '?' : '&') + 'sw=' + (window.SW_CACHE_BUST || '7'); }
          if(story){
            if(titleEl){
              var parts = String(story.heading || '').trim().split(/\s+/);
              var last = parts.pop() || '';
              titleEl.innerHTML = (parts.length ? parts.join(' ') + ' ' : '') + '<em>' + last + '</em>';
            }
            if(subEl) subEl.textContent = story.sub || defaultSub;
            function setImg(el, url, altText){
              if(!el || !url) return;
              el.removeAttribute('srcset');
              if(el.getAttribute('src') !== url) el.src = url;
              el.alt = altText;
            }
            setImg(imgs[0], bust(story.img1), (story.step1 || 'Frisch') + ' – ' + (story.heading || name));
            setImg(imgs[1], bust(story.img2), (story.step2 || 'Belegt') + ' – ' + (story.heading || name));
            setImg(imgs[2], bust(story.img3), (story.step3 || 'Bereit für die Lieferung') + ' – ' + (story.heading || name));
            if(caps[0]) caps[0].textContent = story.step1 || 'Frisch';
            if(caps[1]) caps[1].textContent = story.step2 || 'Belegt';
            if(caps[2]) caps[2].textContent = story.step3 || 'Bereit für die Lieferung';
          } else {
            if(titleEl){
              var p2 = String(name || '').trim().split(/\s+/);
              var l2 = p2.pop() || '';
              titleEl.innerHTML = (p2.length ? p2.join(' ') + ' ' : '') + '<em>' + l2 + '</em>';
            }
            if(subEl) subEl.textContent = defaultSub;
          }
        }

        handwerkEl.style.display = showHw ? 'block' : 'none';
      }

      var chipsEl = document.getElementById('sw-fp-other-chips');
      if(chipsEl){
        chipsEl.innerHTML = '';
        var allCats = Array.from(document.querySelectorAll('.cat-card[data-handle]'));
        var chipIdx = 0;
        allCats.forEach(function(cat){
          if(cat.getAttribute('data-handle') === handle) return;
          var chip = document.createElement('button');
          chip.className = 'sw-fp-other-chip';
          chip.style.animationDelay = (chipIdx * 60) + 'ms';
          var catName = cat.querySelector('.cat-card-name');
          var label = catName ? catName.textContent.trim() : (cat.getAttribute('aria-label') || '');
          chip.textContent = label;
          var chipHandle = cat.getAttribute('data-handle');
          chip.addEventListener('click', function(){
            openCollection(chipHandle, label);
          });
          chipsEl.appendChild(chip);
          chipIdx++;
        });
      }
    })
    .catch(function(){ if(prodList) prodList.innerHTML='<div class="prod-loading">Fehler beim Laden.</div>'; });
}


/* ─── RENDER PRODUCTS ─── */
function renderProducts(products){
  if(!prodList) return;
  if(!products||!products.length){ prodList.innerHTML='<div class="prod-loading">Keine Produkte gefunden.</div>'; return; }
  prodList.innerHTML='';
  products.forEach(function(p){
    var el=document.createElement('div');
    el.className='prod-item';
    var fv=p.variants[0];
    var hasVariants=p.variants.length>1;
    var mainImg=(p.images&&p.images.length>0)?p.images[0].src:(p.image&&p.image.src?p.image.src:'');

    var _minPrice = 0;
    (p.variants||[]).forEach(function(v){
      var pr = parseFloat(v.price);
      if(!isNaN(pr) && pr > 0 && (_minPrice === 0 || pr < _minPrice)) _minPrice = pr;
    });
    if(_minPrice === 0) _minPrice = parseFloat(fv.price) || 0;

    var _displayPrice = _minPrice;

    var rawDesc = (p.body_html||'').replace(/<[^>]+>/g,'').replace(/\s+/g,' ').trim();
    var shortDesc = rawDesc.length > 90 ? rawDesc.slice(0,90).trim()+'\u2026' : rawDesc;

    var varChips = '';
    if(hasVariants){
      var showVars = p.variants.slice(0,4);
      varChips = '<div class="prod-item-chips">';
      showVars.forEach(function(v){
        varChips += '<span class="prod-item-chip">'+v.title+'</span>';
      });
      if(p.variants.length > 4) varChips += '<span class="prod-item-chip prod-item-chip--more">+' + (p.variants.length-4) + '</span>';
      varChips += '</div>';
    }

    el.innerHTML=
      '<div class="prod-item-header">'+
        '<div class="prod-item-info">'+
          '<div class="prod-item-name">'+p.title+'</div>'+
          (shortDesc?'<div class="prod-item-desc">'+shortDesc+'</div>':'')+
          varChips+
        '</div>'+
        '<div class="prod-item-header-right">'+
          '<div class="prod-item-price">'+(hasVariants?'ab ':'')+formatMoney(_displayPrice)+'</div>'+
          '<button class="prod-select-btn" aria-label="\u00d6ffnen">+</button>'+
        '</div>'+
      '</div>';

    el.querySelector('.prod-item-header').addEventListener('click',function(e){
      if(e.target.closest('.prod-select-btn')) return;
      openProductSheet(p);
    });
    el.querySelector('.prod-select-btn').addEventListener('click',function(e){
      e.stopPropagation(); openProductSheet(p);
    });

    var idx2=prodList.children.length;
    setTimeout(function(){ el.classList.add('sw-visible'); },80+idx2*55);
    prodList.appendChild(el);
  });
}


/* ─── PRODUCT BOTTOM SHEET ─── */
function openProductSheet(p){
  var sheet = document.getElementById('sw-product-sheet');
  if(!sheet){ sheet = document.createElement('div'); sheet.id='sw-product-sheet'; document.body.appendChild(sheet); }

  var mainImg = (p.images && p.images.length > 0) ? p.images[0].src : (p.image && p.image.src ? p.image.src : '');
  var imgIdMap = {};
  if(p.images) p.images.forEach(function(img){ if(img.id && img.src) imgIdMap[img.id] = img.src; });

  function vImg(v){
    if(!v.featured_image) return mainImg || '';
    return v.featured_image.src || imgIdMap[v.featured_image.id] || mainImg || '';
  }

  var firstVariant = p.variants[0];
  var hasVariants = p.variants.length > 1;
  var safeTitle = p.title.replace(/"/g, '&quot;');

  var rawDesc = (p.body_html || '').replace(/<style[\s\S]*?<\/style>/gi, '').trim();
  var tmp = document.createElement('div');
  tmp.innerHTML = rawDesc;
  var descHtmlClean = tmp.innerHTML;
  var descText = tmp.textContent || '';

  var _tagsArr = [];
  if(Array.isArray(p.tags)) _tagsArr = p.tags;
  else if(typeof p.tags === 'string') _tagsArr = p.tags.split(/,\s*/);
  var _tagsLc = _tagsArr.map(function(t){ return String(t).toLowerCase(); }).join(' ');
  var _typeLc = String(p.product_type || '').toLowerCase();
  var _titleLc = String(p.title || '').toLowerCase();

  var hasBrot = false;
  var brotSet = '';
  var brotDefaultName = '';
  var brotAltName = 'Rheinisches Vollkornbrot';
  var brotSurchargeCents = 0;
  var _tagsPad = ' ' + _tagsLc + ' ';
  function _hasTag(t){ return _tagsPad.indexOf(' ' + t + ' ') !== -1; }
  if(_hasTag('no-brot')){
    hasBrot = false;
  } else if(_hasTag('brot-stulle')){
    hasBrot = true; brotSet = 'stulle';
    brotDefaultName = 'Sylter Sauerteigbrot';
    brotSurchargeCents = 0;
  } else if(_hasTag('brot-sandwich')){
    hasBrot = true; brotSet = 'sandwich';
    brotDefaultName = 'Sandwich-Toast';
    brotAltName = 'Vollkorn-Toast';
    brotSurchargeCents = 0;
  } else if(_hasTag('brot-stullenplatte')){
    hasBrot = true; brotSet = 'stullenplatte';
    brotDefaultName = 'Sylter Sauerteigbrot';
    brotSurchargeCents = 0;
  } else if(_hasTag('brot-broetchenplatte')){
    hasBrot = true; brotSet = 'broetchenplatte';
    brotDefaultName = 'Helles Brötchen';
    brotAltName = 'Vollkornbrötchen';
    brotSurchargeCents = 500;
  } else if(_hasTag('brot-platte-5')){
    hasBrot = true; brotSet = 'platte-5';
    brotDefaultName = 'Helles Brötchen';
    brotAltName = 'Vollkornbrötchen';
    brotSurchargeCents = 500;
  } else if(_hasTag('brot-broetchen')){
    hasBrot = true; brotSet = 'broetchen';
    brotDefaultName = 'Helles Brötchen';
    brotAltName = 'Vollkornbrötchen';
    brotSurchargeCents = 50;
  }

  var _handleLc = String(p.handle || '').toLowerCase();
  var _hayDip = _tagsLc + ' ' + _handleLc + ' ' + _typeLc + ' ' + _titleLc;
  var _isSateWord = /saate|satay|saté|sate/.test(_hayDip);
  var _isSpiess   = /spieß|spiess/.test(_hayDip);
  var _isStick    = /stick/.test(_hayDip);
  var _isSalat    = /salat/.test(_hayDip);
  var _someVariantNeedsDip = false;
  var _userManagesSauceViaVariants = false;
  p.variants.forEach(function(v){
    var vt = (v.title || '').toLowerCase();
    if(/dip/.test(vt)) _someVariantNeedsDip = true;
    if(/dressing/.test(vt)){
      _isSalat = true;
      _userManagesSauceViaVariants = true;
    }
  });

  var sauceSet = '';
  if(_isSateWord && _isSpiess)  sauceSet = 'spiess';
  else if(_isSalat)             sauceSet = 'salate';
  else if(_isStick)             sauceSet = 'sticks';
  if(_tagsLc.indexOf('sauce-spiess') !== -1) sauceSet = 'spiess';
  if(_tagsLc.indexOf('sauce-sticks') !== -1) sauceSet = 'sticks';
  if(_tagsLc.indexOf('sauce-salate') !== -1) sauceSet = 'salate';
  var hasSauce = sauceSet !== '' || _tagsLc.indexOf('sauce-auswahl') !== -1 || _someVariantNeedsDip;
  if(hasSauce && sauceSet === '') sauceSet = 'spiess';
  var dipWord = (sauceSet === 'salate') ? 'Dressing' : 'Dip';
  var showMainPicker = hasSauce && !_userManagesSauceViaVariants;

  var varHtml = '';
  if(hasVariants){
    p.variants.forEach(function(v, i){
      var vp = formatMoney(v.price);
      var vi = vImg(v);
      var label = v.title.length > 34 ? v.title.substring(0, 34) + '\u2026' : v.title;
      var _needsDip = /dip/i.test(v.title || '') ? 'true' : 'false';
      if(sauceSet === 'sticks' || sauceSet === 'salate') _needsDip = 'true';
      varHtml +=
        '<button class="sw-sheet-var' + (i === 0 ? ' active' : '') + '"' +
        ' data-variant-id="' + v.id + '"' +
        ' data-price="' + v.price + '"' +
        ' data-needs-dip="' + _needsDip + '"' +
        ' data-img="' + (vi || '').replace(/"/g, '&quot;') + '"' +
        ' data-desc="">' +
          label + (vp ? ' <span>' + vp + '</span>' : '') +
        '</button>';
    });
  }

  var brotHtml = '';
  var brotBanner = '';
  if(hasBrot){
    var _vk = (window.SW_BROT && window.SW_BROT.vollkorn) || {};
    var _scFmt = brotSurchargeCents > 0
      ? (brotSurchargeCents/100).toFixed(2).replace('.',',') + ' \u20ac'
      : '';
    var _bannerBody;
    if(brotSurchargeCents > 0){
      var _allBroetchen = (brotSet === 'platte-5' || brotSet === 'broetchenplatte')
        ? ' Gilt f\u00fcr alle 10 Br\u00f6tchen der Platte.'
        : '';
      _bannerBody = 'Standardm\u00e4\u00dfig <strong>' + brotDefaultName + '</strong>. Auf <strong>' + brotAltName + '</strong> upgraden f\u00fcr <span class="sw-brot-banner-plus">+ ' + _scFmt + '</span>.' + _allBroetchen;
    } else {
      _bannerBody = 'W\u00e4hle zwischen <strong>' + brotDefaultName + '</strong> oder <strong>' + brotAltName + '</strong> \u2013 beide ohne Aufpreis.';
    }
    brotBanner = '<div class="sw-brot-banner-top">'
               + '<div class="sw-brot-banner-icon"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg></div>'
               + '<div class="sw-brot-banner-txt">'
               +   '<div class="sw-brot-banner-head">Brotsorte w\u00e4hlen</div>'
               +   '<div class="sw-brot-banner-body">' + _bannerBody + '</div>'
               + '</div>'
               + '</div>';
    var _altPillLabel = brotAltName + (brotSurchargeCents > 0 ? ' <span class="sw-brot-surcharge">+ ' + _scFmt + '</span>' : '');
    brotHtml  = '<div class="sw-brot-label">Brotsorte w\u00e4hlen</div>';
    brotHtml += '<div class="sw-brot-pills">';
    brotHtml += '<button type="button" class="sw-brot-pill active" data-brot-name="' + brotDefaultName + '" data-brot-img="" data-brot-surcharge="0">' + brotDefaultName + '</button>';
    brotHtml += '<button type="button" class="sw-brot-pill" data-brot-name="' + brotAltName + '" data-brot-img="' + (_vk.img||'') + '" data-brot-surcharge="' + brotSurchargeCents + '">' + _altPillLabel + '</button>';
    brotHtml += '</div>';
    brotHtml += '<div class="sw-brot-preview" id="sw-brot-preview" style="display:none"><img class="sw-brot-preview-img" id="sw-brot-preview-img" src="" alt=""></div>';
  }

  var sauceHtml = '';
  if(showMainPicker){
    sauceHtml  = '<div class="sw-sauce-label">' + dipWord + ' wählen <span class="sw-sauce-required">– bitte auswählen</span> <span class="sw-sauce-incl">inkl.</span></div>';
    sauceHtml += '<div class="sw-sauce-pills">';
    if(sauceSet === 'sticks'){
      sauceHtml += '<button type="button" class="sw-sauce-pill" data-sauce="Aioli-Sauce">Aioli-Sauce</button>';
      sauceHtml += '<button type="button" class="sw-sauce-pill" data-sauce="Kräuter-Sauce">Kräuter-Sauce</button>';
      sauceHtml += '<button type="button" class="sw-sauce-pill" data-sauce="Sour Cream">Sour Cream</button>';
    } else if(sauceSet === 'salate'){
      sauceHtml += '<button type="button" class="sw-sauce-pill" data-sauce="American Dressing">American Dressing</button>';
      sauceHtml += '<button type="button" class="sw-sauce-pill" data-sauce="French Dressing">French Dressing</button>';
      sauceHtml += '<button type="button" class="sw-sauce-pill" data-sauce="Italian Dressing">Italian Dressing</button>';
      sauceHtml += '<button type="button" class="sw-sauce-pill" data-sauce="Joghurt Dressing">Joghurt Dressing</button>';
    } else {
      sauceHtml += '<button type="button" class="sw-sauce-pill" data-sauce="Knoblauch-Sauce">Knoblauch-Sauce</button>';
      sauceHtml += '<button type="button" class="sw-sauce-pill" data-sauce="Asia-Sauce">Asia-Sauce</button>';
      sauceHtml += '<button type="button" class="sw-sauce-pill" data-sauce="Curry-Mango-Sauce">Curry-Mango-Sauce</button>';
    }
    var _noneLabel = (sauceSet === 'salate') ? 'Keine' : 'Ohne ' + dipWord;
    sauceHtml += '<button type="button" class="sw-sauce-pill sw-sauce-pill--none" data-sauce="">' + _noneLabel + '</button>';
    sauceHtml += '</div>';
  }

  var dipExtraVid = (window.SW_DIP_EXTRA && window.SW_DIP_EXTRA.variantId) || '';
  var dipExtraPriceCents = (window.SW_DIP_EXTRA && window.SW_DIP_EXTRA.priceCents) || 0;
  var extraHtml = '';
  if(hasSauce && dipExtraVid){
    var _extraSauces;
    if(sauceSet === 'sticks')      _extraSauces = ['Aioli-Sauce','Kräuter-Sauce','Sour Cream'];
    else if(sauceSet === 'salate') _extraSauces = ['American Dressing','French Dressing','Italian Dressing','Joghurt Dressing'];
    else                            _extraSauces = ['Knoblauch-Sauce','Asia-Sauce','Curry-Mango-Sauce'];
    var _priceLbl = formatMoney(dipExtraPriceCents);
    extraHtml  = '<div class="sw-dip-extra-label">Extra-' + dipWord + ' dazu? <span class="sw-dip-extra-optional">(optional)</span><span class="sw-dip-extra-price-info">' + _priceLbl + ' pro ' + dipWord + '</span></div>';
    extraHtml += '<div class="sw-dip-extra-rows">';
    _extraSauces.forEach(function(s){
      extraHtml += '<div class="sw-dip-extra-row" data-sauce="' + s + '">'
        + '<span class="sw-dip-extra-row-name">' + s + '</span>'
        + '<div class="sw-dip-extra-counter">'
          + '<button type="button" class="sw-dip-extra-btn sw-dip-extra-minus" data-sauce="' + s + '" aria-label="Weniger">\u2212</button>'
          + '<span class="sw-dip-extra-count" data-sauce="' + s + '">0</span>'
          + '<button type="button" class="sw-dip-extra-btn sw-dip-extra-plus" data-sauce="' + s + '" aria-label="Mehr">+</button>'
        + '</div>'
      + '</div>';
    });
    extraHtml += '</div>';
  }

  var parts = [];
  parts.push('<div class="sw-sheet-backdrop"></div>');
  parts.push('<div class="sw-sheet-panel">');
  parts.push(  '<button class="sw-sheet-close"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>');
  if(mainImg && !hasBrot){
    parts.push('<div class="sw-sheet-img-wrap"><img class="sw-sheet-img" id="sw-sheet-main-img" src="' + mainImg + '" alt="' + safeTitle + '"></div>');
  }
  parts.push(  '<div class="sw-sheet-body" style="clear:both">');
  if(brotBanner){ parts.push(brotBanner); }
  parts.push(    '<div class="sw-sheet-eyebrow">Stullenwerk Hamburg</div>');
  parts.push(    '<h2 class="sw-sheet-title">' + p.title + '</h2>');
  var _initVarLabel = (hasVariants && firstVariant.title && firstVariant.title !== 'Default Title') ? firstVariant.title : '';
  parts.push(    '<div class="sw-sheet-variant-label" id="sw-sheet-variant-label">' + _initVarLabel + '</div>');
  parts.push(    '<div class="sw-sheet-price" id="sw-sheet-price" style="display:none">' + formatMoney(firstVariant.price) + '</div>');
  if(descText.length > 3){
    parts.push(  '<div class="sw-sheet-desc-label">Produktbeschreibung</div>');
    parts.push(  '<div class="sw-sheet-desc sw-html-content">' + descHtmlClean + '</div>');
  }
  if(hasVariants){
    parts.push(  '<div class="sw-sheet-var-label">Variante w\u00e4hlen</div>');
    parts.push(  '<div class="sw-sheet-vars">' + varHtml + '</div>');
    parts.push(  '<div id="sw-sheet-var-desc" class="sw-sheet-var-desc"></div>');
  }
  if(brotHtml){
    parts.push(  '<div class="sw-brot-section">' + brotHtml + '</div>');
  }
  if(sauceHtml){
    parts.push(  '<div class="sw-sauce-section">' + sauceHtml + '</div>');
  }
  if(extraHtml){
    parts.push(  '<div class="sw-dip-extra-section">' + extraHtml + '</div>');
  }
  parts.push(    '<div class="sw-sheet-footer">');
  parts.push(      '<div class="sw-sheet-qty-row">');
  parts.push(        '<button class="sw-sheet-qty-btn" id="sw-sq-minus">\u2212</button>');
  parts.push(        '<span class="sw-sheet-qty-val" id="sw-sq-val">1</span>');
  parts.push(        '<button class="sw-sheet-qty-btn" id="sw-sq-plus">+</button>');
  parts.push(      '</div>');
  parts.push(      '<button class="sw-sheet-add-btn" id="sw-sheet-add-btn" data-variant="' + firstVariant.id + '" data-price="' + firstVariant.price + '" data-title="' + safeTitle + '">');
  parts.push(        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39A2 2 0 0 0 9.68 16h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>');
  parts.push(        'In den Anfragekorb');
  parts.push(      '</button>');
  parts.push(    '</div>');
  parts.push(  '</div>');
  parts.push('</div>');

  sheet.innerHTML = parts.join('');
  sheet.style.display = 'block';

  var _scrollY = window.scrollY;
  document.body.classList.add('sw-sheet-body-lock');
  document.body.style.top = (-_scrollY) + 'px';
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ sheet.classList.add('sw-sheet-open'); }); });

  var _vDescs = {};
  if(p.handle){
    fetch('/products/' + p.handle)
      .then(function(r){ return r.text(); })
      .then(function(html){
        var m = html.match(/<script[^>]+id="sw-variant-descs"[^>]*>([\s\S]*?)<\/script>/);
        if(m){
          try{ _vDescs = JSON.parse(m[1]); }catch(e){}
        }
        var firstActive = sheet.querySelector('.sw-sheet-var.active');
        if(firstActive) swSheetShowDesc(firstActive.dataset.variantId);
      }).catch(function(){});
  }

  function swSheetShowDesc(vid){
    var box = sheet.querySelector('#sw-sheet-var-desc');
    var label = sheet.querySelector('#sw-sheet-var-desc-label');
    if(!box) return;
    var txt = (_vDescs[vid] || '').trim();
    if(!txt){
      box.style.display = 'none';
      box.textContent = '';
      if(label) label.style.display = 'none';
      return;
    }
    box.textContent = txt;
    box.style.display = 'block';
    if(label) label.style.display = 'block';
    box.style.animation = 'none';
    box.offsetHeight;
    box.style.animation = '';
  }

  var sq = 1;
  var addBtn  = sheet.querySelector('#sw-sheet-add-btn');
  var priceEl = sheet.querySelector('#sw-sheet-price');
  var sqVal   = sheet.querySelector('#sw-sq-val');

  function closeSheet(){
    sheet.classList.remove('sw-sheet-open');
    var scrollY = parseInt(document.body.style.top || '0', 10);
    document.body.classList.remove('sw-sheet-body-lock');
    document.body.style.top = '';
    document.body.style.overflow = '';
    window.scrollTo(0, -scrollY);
    document.removeEventListener('keydown', _sheetEscHandler);
    window.removeEventListener('popstate', _sheetPopHandler);
    setTimeout(function(){ sheet.style.display = 'none'; sheet.innerHTML = ''; }, 350);
  }

  sheet.querySelector('.sw-sheet-backdrop').addEventListener('click', closeSheet);
  sheet.querySelector('.sw-sheet-close').addEventListener('click', closeSheet);

  var _sheetEscHandler = function(e){ if(e.key === 'Escape') closeSheet(); };
  document.addEventListener('keydown', _sheetEscHandler);

  history.pushState({sheet: true}, '', '');
  var _sheetPopHandler = function(){ if(sheet.classList.contains('sw-sheet-open')) closeSheet(); };
  window.addEventListener('popstate', _sheetPopHandler);

  sheet.querySelector('#sw-sq-minus').addEventListener('click', function(){ if(sq > 1){ sq--; sqVal.textContent = sq; recalcPrice(); } });
  sheet.querySelector('#sw-sq-plus').addEventListener('click', function(){ sq++; sqVal.textContent = sq; recalcPrice(); });

  function recalcPrice(){
    var b = parseFloat(addBtn.dataset.price || 0);
    if(b && priceEl) priceEl.textContent = formatMoney(b * sq);
  }

  sheet.querySelectorAll('.sw-sheet-var').forEach(function(vBtn){
    vBtn.addEventListener('click', function(){
      sheet.querySelectorAll('.sw-sheet-var').forEach(function(b){ b.classList.remove('active'); });
      this.classList.add('active');
      addBtn.dataset.variant = this.dataset.variantId;
      addBtn.dataset.price = this.dataset.price;
      recalcPrice();
      var _vlabel = sheet.querySelector('#sw-sheet-variant-label');
      if(_vlabel){
        var _btnText = (this.textContent || '').replace(/\s+/g, ' ').trim();
        var _priceMatch = _btnText.match(/(.*?)\s+\d+[,.]\d+\s*\u20ac\s*$/);
        _vlabel.textContent = _priceMatch ? _priceMatch[1].trim() : _btnText;
      }
      var imgSrc = this.dataset.img;
      if(imgSrc){
        var mainImgEl = sheet.querySelector('#sw-sheet-main-img');
        if(mainImgEl && mainImgEl.dataset.current !== imgSrc){
          mainImgEl.dataset.current = imgSrc;
          mainImgEl.style.opacity = '0';
          setTimeout(function(){
            mainImgEl.src = imgSrc;
            mainImgEl.onload = function(){ mainImgEl.style.opacity = '1'; };
          }, 180);
        }
      }
      swSheetShowDesc(this.dataset.variantId);
      if(typeof syncSauceSectionForVariant === 'function'){
        syncSauceSectionForVariant(this.dataset.needsDip === 'true');
      }
    });
  });

  var selectedBrot = null;
  var selectedBrotSurcharge = 0;
  (function(){
    var firstActive = sheet.querySelector('.sw-brot-pill.active');
    if(firstActive){
      selectedBrot = firstActive.dataset.brotName;
      selectedBrotSurcharge = parseInt(firstActive.dataset.brotSurcharge || 0, 10);
    }
  })();
  recalcPrice = function(){
    var b = parseFloat(addBtn.dataset.price || 0);
    var baseEur = (b >= 100 && b === Math.floor(b)) ? b/100 : b;
    var total = (baseEur * sq) + ((selectedBrotSurcharge||0)/100 * sq);
    if(priceEl) priceEl.textContent = formatMoney(total);
  };
  sheet.querySelectorAll('.sw-brot-pill').forEach(function(pill){
    pill.addEventListener('click', function(){
      if(this.classList.contains('active')) return;
      var preview    = sheet.querySelector('#sw-brot-preview');
      var previewImg = sheet.querySelector('#sw-brot-preview-img');
      sheet.querySelectorAll('.sw-brot-pill').forEach(function(p){ p.classList.remove('active'); });
      this.classList.add('active');
      selectedBrot = this.dataset.brotName;
      selectedBrotSurcharge = parseInt(this.dataset.brotSurcharge || 0, 10);
      recalcPrice();
      var brotSrc = this.dataset.brotImg;
      if(preview && previewImg && brotSrc){
        previewImg.src = brotSrc;
        previewImg.alt = selectedBrot;
        preview.style.display = 'block';
      } else if(preview){
        preview.style.display = 'none';
      }
    });
  });

  var selectedSauce = null;
  var sauceSection = sheet.querySelector('.sw-sauce-section');
  var addBtnDefaultHTML = addBtn.innerHTML;

  function dipNeededNow(){
    if(!hasSauce || !sauceSection) return false;
    return sauceSection.style.display !== 'none';
  }

  function refreshAddBtnSauceState(){
    if(dipNeededNow() && selectedSauce === null){
      addBtn.disabled = true;
      addBtn.style.opacity = '.55';
      addBtn.style.cursor = 'not-allowed';
      addBtn.innerHTML = 'Bitte ' + dipWord + ' wählen';
    } else {
      addBtn.disabled = false;
      addBtn.style.opacity = '';
      addBtn.style.cursor = '';
      addBtn.innerHTML = addBtnDefaultHTML;
    }
  }

  function syncSauceSectionForVariant(needsDip){
    if(!sauceSection) return;
    if(needsDip){
      sauceSection.style.display = '';
    } else {
      sauceSection.style.display = 'none';
      selectedSauce = null;
      sheet.querySelectorAll('.sw-sauce-pill').forEach(function(p){ p.classList.remove('active'); });
    }
    refreshAddBtnSauceState();
  }

  sheet.querySelectorAll('.sw-sauce-pill').forEach(function(pill){
    pill.addEventListener('click', function(){
      sheet.querySelectorAll('.sw-sauce-pill').forEach(function(p){ p.classList.remove('active'); });
      this.classList.add('active');
      selectedSauce = this.dataset.sauce;
      refreshAddBtnSauceState();
    });
  });

  var dipExtras = {};
  if(hasSauce && !dipExtraVid){
    var _es = sheet.querySelector('.sw-dip-extra-section');
    if(_es) _es.style.display = 'none';
    console.warn('[Stullenwerk] Extra-Dip-Counter ausgeblendet: Theme-Setting fehlt.');
  }
  sheet.querySelectorAll('.sw-dip-extra-btn').forEach(function(b){
    b.addEventListener('click', function(){
      var s = this.dataset.sauce;
      var isPlus = this.classList.contains('sw-dip-extra-plus');
      var cur = dipExtras[s] || 0;
      var nq = isPlus ? cur + 1 : Math.max(0, cur - 1);
      dipExtras[s] = nq;
      var cnt = sheet.querySelector('.sw-dip-extra-count[data-sauce="' + s + '"]');
      if(cnt) cnt.textContent = nq;
      var row = sheet.querySelector('.sw-dip-extra-row[data-sauce="' + s + '"]');
      if(row) row.classList.toggle('active', nq > 0);
    });
  });

  (function(){
    if(!hasSauce) return;
    var firstActive = sheet.querySelector('.sw-sheet-var.active');
    var needs = firstActive
      ? firstActive.dataset.needsDip === 'true'
      : (p.variants.length === 1 ? true : /dip/i.test(firstVariant.title || ''));
    syncSauceSectionForVariant(needs);
  })();

  addBtn.addEventListener('click', function(){
    var vid = this.dataset.variant, title = this.dataset.title;
    if(!vid) return;
    if(dipNeededNow() && selectedSauce === null){ refreshAddBtnSauceState(); return; }
    this.disabled = true;
    this.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg> Hinzugef\u00fcgt!';
    var props = null;
    if(hasBrot && selectedBrot){
      props = { 'Brotsorte': selectedBrot };
      if(selectedBrotSurcharge){
        props['Brot-Aufpreis'] = (selectedBrotSurcharge/100).toFixed(2).replace('.',',') + ' \u20ac';
      }
    }
    if(dipNeededNow() && selectedSauce){
      if(!props) props = {};
      props['Sauce'] = selectedSauce;
    }
    var _plattenInhalt = (window.SW_getPlattenInhalt && window.SW_getPlattenInhalt(title, title)) || '';
    if(_plattenInhalt){
      if(!props) props = {};
      props['Inhalt'] = _plattenInhalt;
    }
    var _scMap = (window.SW_BROT && window.SW_BROT.surchargeMap) || {};
    var scVid = _scMap[selectedBrotSurcharge] || '';
    var extras = [];
    if(hasBrot && selectedBrot && selectedBrotSurcharge && scVid){
      extras.push({
        variantId: parseInt(scVid, 10),
        qty: sq,
        props: { 'Brotsorte': selectedBrot, 'Zu': title }
      });
    }
    if(dipExtraVid){
      Object.keys(dipExtras).forEach(function(s){
        if(dipExtras[s] > 0){
          extras.push({
            variantId: parseInt(dipExtraVid, 10),
            qty: dipExtras[s],
            props: { 'Sauce': s, 'Zu': title }
          });
        }
      });
    }
    addToCart(parseInt(vid, 10), sq, title, props, extras);

    // Modal bleibt offen — Reset für nächste Auswahl
    var _btn = this;
    setTimeout(function(){
      _btn.disabled = false;
      _btn.innerHTML = addBtnDefaultHTML;
      sq = 1;
      if(sqVal) sqVal.textContent = '1';
      if(hasSauce){
        selectedSauce = null;
        sheet.querySelectorAll('.sw-sauce-pill').forEach(function(p){ p.classList.remove('active'); });
      }
      Object.keys(dipExtras).forEach(function(s){
        dipExtras[s] = 0;
        var cnt = sheet.querySelector('.sw-dip-extra-count[data-sauce="'+s+'"]');
        if(cnt) cnt.textContent = '0';
        var row = sheet.querySelector('.sw-dip-extra-row[data-sauce="'+s+'"]');
        if(row) row.classList.remove('active');
      });
      recalcPrice();
      refreshAddBtnSauceState();
      var firstVar = sheet.querySelector('.sw-sheet-var');
      if(firstVar){
        firstVar.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
    }, 1200);
  });
}


function showSidePanel(productEl, title, desc){
  var panel = document.getElementById('desc-side-panel');
  if(!panel) return;
  document.getElementById('desc-panel-title').textContent = title;
  document.getElementById('desc-panel-text').textContent = desc;
  var rect = productEl.getBoundingClientRect();
  var listRect = document.getElementById('prod-list').getBoundingClientRect();
  panel.style.top = (rect.top - listRect.top + document.getElementById('prod-list').scrollTop) + 'px';
  panel.classList.add('visible');
  productEl.classList.add('has-panel');
}

function hideSidePanel(){
  var panel = document.getElementById('desc-side-panel');
  if(panel) panel.classList.remove('visible');
  document.querySelectorAll('.prod-item.has-panel').forEach(function(i){ i.classList.remove('has-panel'); });
}

function formatMoney(val){
  var n = parseFloat(val);
  if(isNaN(n)) return val;
  if(n >= 100 && n === Math.floor(n)) n = n / 100;
  return n.toFixed(2).replace('.',',') + ' \u20ac';
}

/* ─── ADD TO CART ─── */
function addToCart(variantId, qty, title, properties, extras){
  if(!variantId){ showToast('Bitte zuerst eine Variante w\u00e4hlen', true); return; }
  qty = parseInt(qty, 10) || 1;
  variantId = parseInt(variantId, 10);
  updateCartNote();

  if(footerAddBtn){
    footerAddBtn.disabled = true;
    footerAddBtn.style.opacity = '.6';
    footerAddBtn.textContent = '\u2026';
  }

  var extrasArr = [];
  if(Array.isArray(extras)) extrasArr = extras.slice();
  else if(extras && extras.variantId) extrasArr = [extras];

  var payload = { id: variantId, quantity: qty };
  if(properties && Object.keys(properties).length > 0) payload.properties = properties;

  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify(payload)
  })
  .then(function(r){ return r.json(); })
  .then(function(data){
    if(data.status && data.status >= 400){
      showToast('Fehler \u2013 bitte erneut versuchen', true);
      return;
    }
    function addNextExtra(){
      if(!extrasArr.length) return Promise.resolve();
      var ex = extrasArr.shift();
      var exPayload = { id: parseInt(ex.variantId, 10), quantity: parseInt(ex.qty || 1, 10) };
      if(ex.props && Object.keys(ex.props).length > 0) exPayload.properties = ex.props;
      return fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify(exPayload)
      })
      .then(function(r){
        if(!r.ok){
          return r.json().then(function(err){
            console.error('[Stullenwerk] Add-on item failed:', err, exPayload);
            var sauceLabel = (ex.props && ex.props.Sauce) ? ex.props.Sauce : 'Aufpreis';
            showToast('Konnte "'+sauceLabel+'" nicht hinzufügen – Theme-Setting prüfen', true);
            return null;
          });
        }
        return r.json();
      })
      .then(addNextExtra);
    }
    return addNextExtra().then(function(){
      updateBadge();
      showToast(qty + 'x ' + title + ' hinzugef\u00fcgt \u2713');
      setTimeout(function(){
        if(overlayFooter) overlayFooter.style.display = 'none';
        document.querySelectorAll('.prod-item').forEach(function(i){ i.classList.remove('selected'); });
        selectedVariantId = null;
        selectedTitle = '';
        selectedQty = 1;
      }, 80);
    });
  })
  .catch(function(err){
    console.error('Cart error:', err);
    showToast('Fehler \u2013 bitte erneut versuchen', true);
  })
  .finally(function(){
    if(footerAddBtn){
      footerAddBtn.disabled = false;
      footerAddBtn.style.opacity = '';
      footerAddBtn.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39A2 2 0 0 0 9.68 16h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> In den Anfragekorb';
    }
  });
}

/* ─── CLOSE OVERLAY ─── */
if(prodBack) prodBack.addEventListener('click', closeOverlay);
if(overlay) overlay.addEventListener('click', function(e){ if(e.target === overlay) closeOverlay(); });
document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeOverlay(); });

function closeOverlay(){
  if(!overlay) return;
  overlay.classList.remove('sw-open');
  document.dispatchEvent(new CustomEvent('sw:close'));
  setTimeout(function(){ overlay.style.display = 'none'; }, 350);
  document.body.style.overflow = '';
  if(overlayFooter) overlayFooter.style.display = 'none';
  selectedVariantId = null;
}

/* ─── TOAST ─── */
function showToast(msg, isError){
  var existing = document.getElementById('sw-cart-popup');
  if(existing){ existing.classList.remove('sw-cp-show'); setTimeout(function(){ existing.remove(); }, 200); }

  var popup = document.createElement('div');
  popup.id = 'sw-cart-popup';
  popup.className = isError ? 'sw-cart-popup sw-cart-popup--error' : 'sw-cart-popup';

  if(!isError){
    var match = msg.match(/^(\d+)x (.+?) hinzugef\u00fcgt/);
    var pQty = match ? match[1] : '1';
    var pName = match ? match[2] : msg.replace(' hinzugef\u00fcgt \u2713','');
    popup.innerHTML =
      '<div class="sw-cp-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg></div>'+
      '<div class="sw-cp-info">'+
        '<span class="sw-cp-label">Zum Anfragekorb hinzugef\u00fcgt</span>'+
        '<span class="sw-cp-name">'+(pQty > 1 ? pQty+'\u00d7 ' : '')+pName+'</span>'+
      '</div>'+
      '<a href="/cart" class="sw-cp-action">Korb <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg></a>';
  } else {
    popup.innerHTML =
      '<div class="sw-cp-check sw-cp-check--err"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></div>'+
      '<div class="sw-cp-info"><span class="sw-cp-label">'+msg+'</span></div>';
  }

  document.body.appendChild(popup);
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ popup.classList.add('sw-cp-show'); }); });
  var t = setTimeout(function(){
    popup.classList.remove('sw-cp-show');
    setTimeout(function(){ if(popup.parentNode) popup.remove(); }, 400);
  }, 3800);
  popup.addEventListener('click', function(e){
    if(e.target.closest('.sw-cp-action')) return;
    clearTimeout(t);
    popup.classList.remove('sw-cp-show');
    setTimeout(function(){ if(popup.parentNode) popup.remove(); }, 400);
  });
}

/* ─── CUSTOM TIME PICKER ─── */
(function(){
  var picker = document.getElementById('time-picker');
  var btn    = document.getElementById('time-picker-btn');
  var drop   = document.getElementById('time-picker-drop');
  var label  = document.getElementById('time-picker-label');
  var hidden = document.getElementById('del-time');
  if(!picker||!btn||!drop) return;

  btn.addEventListener('click', function(e){
    e.stopPropagation();
    picker.classList.toggle('open');
  });

  drop.querySelectorAll('.tp-opt').forEach(function(opt){
    opt.addEventListener('click', function(){
      var val = this.getAttribute('data-val');
      if(hidden) hidden.value = val;
      label.textContent = val ? this.textContent : 'Uhrzeit w\u00e4hlen';
      drop.querySelectorAll('.tp-opt').forEach(function(o){ o.classList.remove('active'); });
      this.classList.add('active');
      picker.classList.remove('open');
      sessionStorage.setItem('sw_delivery_time', val);
      updateCartNote();
    });
  });

  document.addEventListener('click', function(e){
    if(!picker.contains(e.target)) picker.classList.remove('open');
  });
})();

window.SW_MIN_SATURDAY = window.SW_MIN_SATURDAY || 120;
window.SW_MIN_SUNDAY = window.SW_MIN_SUNDAY || 200;

/* ─── PLZ PR\u00dcFEN ─── */
(function(){
  var HH_PLZ = [
    20095,20097,20099,20144,20146,20148,20149,
    20249,20251,20253,20255,20257,20259,
    20354,20355,20357,20359,
    20457,20459,
    20535,20537,20539,
    21029,21031,21033,21035,21037,21039,
    21073,21075,21077,21079,
    21107,21109,21129,21147,21149,
    22041,22043,22045,22047,22049,
    22081,22083,22085,22087,22089,
    22111,22113,22115,22117,22119,
    22143,22145,22147,22149,22159,
    22175,22177,22179,
    22297,22299,22301,22303,22305,22307,22309,
    22335,22337,22339,22359,
    22391,22393,22395,22397,22399,
    22415,22417,22419,
    22453,22455,22457,22459,
    22523,22525,22527,22529,
    22547,22549,22559,
    22587,22589,
    22605,22607,22609,
    22761,22763,22765,22767,22769
  ];

  var trigger = document.getElementById('plz-trigger');
  var popup   = document.getElementById('plz-popup');
  var closeBtn= document.getElementById('plz-close');
  var input   = document.getElementById('plz-input');
  var checkBtn= document.getElementById('plz-check');
  var result  = document.getElementById('plz-result');

  function openPopup(){
    if(!popup) return;
    popup.setAttribute('aria-hidden','false');
    popup.classList.add('open');
    setTimeout(function(){ if(input) input.focus(); }, 350);
  }
  function closePopup(){
    if(!popup) return;
    popup.classList.remove('open');
    popup.setAttribute('aria-hidden','true');
    setTimeout(function(){
      if(input) input.value='';
      if(result){ result.textContent=''; result.className='plz-result'; }
    }, 300);
  }
  function checkPLZ(){
    if(!input||!result) return;
    var val = input.value.trim();
    if(!/^\d{5}$/.test(val)){
      result.textContent='Bitte eine g\u00fcltige 5-stellige PLZ eingeben.';
      result.className='plz-result error';
      return;
    }
    var num = parseInt(val, 10);
    if(HH_PLZ.indexOf(num) !== -1){
      result.textContent='Super! Wir liefern in dein Gebiet.';
      result.className='plz-result success';
    } else {
      result.textContent='Sorry, aktuell liefern wir nicht in deinem Gebiet :(';
      result.className='plz-result error';
    }
  }

  if(trigger) trigger.addEventListener('click', openPopup);
  if(closeBtn) closeBtn.addEventListener('click', closePopup);
  if(popup) popup.addEventListener('click', function(e){ if(e.target===popup) closePopup(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closePopup(); });
  if(checkBtn) checkBtn.addEventListener('click', checkPLZ);
  if(input) input.addEventListener('keydown', function(e){ if(e.key==='Enter') checkPLZ(); });
  if(input) input.addEventListener('input', function(){
    this.value = this.value.replace(/\D/g,'').slice(0,5);
    if(result){ result.textContent=''; result.className='plz-result'; }
  });
})();

/* ─── SMOOTH SCROLL FOR ANCHOR LINKS ─── */
document.addEventListener('click', function(e){
  var link = e.target.closest('a[href^="#"]');
  if(!link) return;
  var id = link.getAttribute('href').slice(1);
  if(!id) return;
  var target = document.getElementById(id);
  if(target){
    e.preventDefault();
    target.scrollIntoView({behavior: 'smooth'});
  }
});

/* ─── EXPORTS ─── */
window.SW_updateBadge = updateBadge;
window.SW_showToast = showToast;

})();